import React, { useState,useEffect } from "react"
import { db } from "../../Lib/Firebase/Firebase"

import LocationMarker from "../GoogleMap/LocationMarker";
import GoogleMapReact from "google-map-react";
import "../GoogleMap/GoogleMap.css"



import "./AdminSettings.css"
const AdminSettings = () => {

// get the list of user info from firebase 1️⃣
// display user info on the page 2️⃣
// change user info status with confirm buttom3️⃣
// update user info to change the card status/date to none3️⃣
// if user status is not === "none" display it on the map4️⃣ 


let [showMapInfo,setShowMapInfo] = useState("")


let [usersObj,SetUsersObj] = useState([])

// 1️⃣gotteb user info
useEffect(()=>{ 
  db.on("value",(snapshot)=>{
    let profile = snapshot.val()
    let fullListOfProfiles=[]
    for( let id in profile){
      let newObj=profile[id]
        newObj.UserId=id
      
        fullListOfProfiles.push(newObj)
    }
    SetUsersObj(fullListOfProfiles)

  })
},[])




// 3️⃣ confirm button changes booking status
function confirmUsersRequest(userid){

  db.child(userid).update({
    bookingStatus:"Accepted",
  })
}


// 3️⃣ remove button changes booking status to declined
function DeclineUsersRequest(userid){
  db.child(userid).update({
    bookingStatus:"Declined",
    date:"choose Another Date"
  })
}

// 3️⃣ remove button changes booking status to declined
function RemoveUsersRequest(userid){
  db.child(userid).update({
    bookingStatus:"none",
    date:"none"
  })
}

const defaultProps = {
  center: {
    lat: 52.489471,
    lng: -1.898575
  },
  zoom: 10
};

function onHover(name){
  setShowMapInfo(name)
}



  return ( 
    <>
      <div className="map adminmap" style={{alignSelf:"center"}}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_MAPS_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
        {usersObj.map((firebaseUser,index)=>{

          return firebaseUser.bookingStatus === "Accepted"?
          
          <LocationMarker key={index} onHover={()=>
            onHover(
              [
                <h6 className="shown-info">Name: {firebaseUser.displayName}</h6>,
                <h6 className="shown-info">Number: {firebaseUser.PhoneNumber}</h6>,
                <h6 className="shown-info">postcode: {firebaseUser.postcode}</h6>,
                <h6 className="shown-info">Address: {firebaseUser.Address}</h6>
              ]
              )
          }
          lat={firebaseUser.lati} lng={firebaseUser.longi}/>:
          
          <React.Fragment key={index}></React.Fragment>
        })}
        
      </GoogleMapReact>
      
      </div>



{/* ----------------------------------- */}
      <div className="shownContainer">{showMapInfo}</div>
{/* ------------------------------------ */}



    <div className="admin-Container">
      {usersObj.map((user,index)=>{
        // 2️⃣displayed it to the screen

        

        return (user.bookingStatus !== "none" && user.bookingStatus !== "Declined")?(
          <li key={index} className="admin-Container__UserInfo">
            <div className="admin-Container__UserInfo-container">

            
              <b>Name: <br/> {user.displayName}</b>
              <b>Date: <br/> {user.date}</b>
              <b>Postcode:<br/> {user.postcode}</b>
              <b>Address:<br/> {user.Address}</b>

              <b>numb:<br/>{user.PhoneNumber}</b>
              <b>service:<br/> {user.service}</b>

              <b className="status" style={user.bookingStatus === "Accepted"?{backgroundColor:"greenyellow"}:{backgroundColor:"orange"}}>Status:<br/>{user.bookingStatus}</b>
            
            <button style={{display:user.bookingStatus === "Accepted"? "none":"inline-block" }}
             className="admin-Container__UserInfo-button1"
            onClick={()=>confirmUsersRequest(user.UserId)}
            > Accept
            </button>
            
            <button className="admin-Container__UserInfo-button2"
            onClick={()=>
              user.bookingStatus === "Accepted"?
              RemoveUsersRequest(user.UserId): DeclineUsersRequest(user.UserId)}
            >{user.bookingStatus === "Accepted"?"Remove":"Decline"}
            
            </button>
              
            </div>

            
          </li>
        ):<React.Fragment key={index}></React.Fragment>


      })}
    </div>
    </>
   );
}
 
export default AdminSettings;